/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'backbone',
        'assets/js/modules/OperationProcessor',
        'assets/js/common/router/index',
        'assets/js/modules/widgets/gallery/gallery',
        'assets/js/modules/widgets/gallery/model/galleryModel',
        'assets/js/modules/widgets/gallery/model/templateModel',
        'assets/js/modules/widgets/startFiles/startFileWidget',
        'assets/js/modules/widgets/startFiles/startFileWidgetModel',
        'assets/js/modules/product/model/productModel',
        'assets/js/modules/product/model/designerModel',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/widgets/pricingCalculator/model/pricingCalcModel',
        'assets/js/modules/widgets/pricingCalculator/pricingCalculator',
        'assets/js/modules/utils',
        'assets/js/modules/browser',
        'assets/js/modules/api/product',
        'assets/js/modules/api/pricing',
        'assets/js/modules/api/customers',
        'assets/js/modules/translator',
        'jquery-ui/jquery-ui'
    ],
    function(
        $,
        _,
        backbone,
        OperationProcessor,
        router,
        Gallery,
        GalleryModel,
        TemplateModel,
        StartFileWidget,
        StartFileWidgetModel,
        ProductModel,
        DesignerModel,
        AttributeModel,
        OptionModel,
        OptionValueModel,
        PricingCalcModel,
        PricingCalculator,
        utils,
        browser,
        productApi,
        pricingApi,
        customersApi,
        translator
    ) {
        var HIDDEN_OPTION_NAMES = [OptionModel.NAME_MAILING_SERVICE, OptionModel.NAME_MAGNETS];

        var ERROR_TXT_ZIP_REQUIRED = translator.trans('error.field_required');
        var ERROR_TXT_ZIP_NOT_VALID = translator.trans('start_page_error.zip_not_valid', {}, 'start_page');

        var StartPage = function(model) {
            this.model = model;

            _.extend(this, backbone.Events);

            var pricingCalcModel = new PricingCalcModel({
                vatRate: parseInt($('.pricing').data('vatRate')),
                eventAgent: model.get('eventAgent')
            });
            this.model.set('pricingCalc', pricingCalcModel);
            this.pricingCalculator = new PricingCalculator(pricingCalcModel);

            this.init();
        };

        StartPage.prototype = {
            init: function() {
                this.events();

                if (this.model.get('showGallery')) {
                    this.initGallery();
                }
            },

            events: function() {
                var _this = this;

                this.listenTo(this.model, {
                    'pricing:init': function() {
                        _this.initPricing();
                    },
                    'change:product': function() {
                        var pricingCalcItem = _this.model.get('pricingCalcItems').find(function(item) {
                            return item.get('product').get('slug') === _this.model.get('product').get('slug');
                        });
                        if (pricingCalcItem) {
                            _this.pricingCalculator.makeSimilar(pricingCalcItem, _this.model.get('pricingCalcItem'));
                            _this.model.set('pricingCalcItem', pricingCalcItem);
                            if (_this.hasMailingService()) {
                                _this.model.get('mailingService').set('itemId', _this.getSelectedSkuId());
                            }
                            _this.savePricingOptions();
                        }
                    },
                    'change:pricingCalcItem': function(model, pricingCalcItem) {
                        _this.pricingCalculator.setItems([pricingCalcItem]);
                        _this.pricingCalculator.updateTotalPrice();
                        _this.model.trigger('PricingCalcItem:changed');
                        _this.updateShippingPrices();
                        _this.savePricingOptions();
                    },
                    'product:beforeChange': function(productSlug) {
                        _this.changeProduct(productSlug);
                    },
                    'pricingCalcItem:changeOption': function(optionName, optionValueName) {
                        if (optionName === OptionModel.NAME_MAILING_SERVICE) {
                            _this.updateMailingServiceOption(optionValueName);
                        }
                    }
                });

                this.listenTo(this.model.get('eventAgent'), {
                    'PricingCalculator:changed': function(pricingCalcItem, isSkuChanged, isOptionSetChanged, isSideCountChanged) {
                        _this.model.get('mailingService').set('itemId', _this.getSelectedSkuId());
                        if (isOptionSetChanged || isSideCountChanged) {
                            _this.model.get('mailingService').set(
                                'maxQuantity',
                                _this.model
                                    .get('pricingCalcItem')
                                    .get('skus')
                                    .last()
                                    .get('sku')
                                    .get('quantity')
                            );
                        }
                        _this.updateShippingPrices();
                        _this.savePricingOptions();
                    },
                    'PricingCalculator:priceChanged': function() {
                        _this.updateTotalPrices();
                    },
                    'DvsDesigner:change:sideCount': function(sideCount) {
                        _this.pricingCalculator.changeSide(sideCount, _this.model.get('pricingCalcItem'));
                    },
                    goToUploadPage: function() {
                        document.location = router.generate('/upload/{slug}', {
                            slug: _this.model.get('product').get('slug')
                        });
                    },
                    goToGalleryPage: function() {
                        var galleryPath = _this.getGalleryPagePath();
                        if (galleryPath) {
                            document.location = galleryPath;
                        }
                    },
                    submitPricingForm: function(zip) {
                        if (_this.model.get('pricingCalcItem')) {
                            _this.updateShippingPrices();
                            _this.savePricingOptions();
                        }
                    },
                    'PricingCalculator:changeShipping': function(shipping) {
                        if (shipping !== undefined) {
                            _this.model.get('pricingCalc').setShipping(shipping);
                        } else {
                            _this.model.get('pricingCalc').dropShipping();
                        }
                    }
                });

                this.listenTo(this.model.get('mailingService'), {
                    'change:price': function() {
                        _this.updateTotalPrices();
                    },
                    // store mailing class changes even if quantity is not selected
                    'change:mailingClass': function() {
                        if (!_this.model.get('mailingService').get('quantity')) {
                            _this.savePricingOptions();
                        }
                    },
                    'change:quantity': function() {
                        var pricingCalcItem = _this.model.get('pricingCalcItem');
                        var itemQuantity = pricingCalcItem
                            .getSelectedSku()
                            .get('sku')
                            .get('quantity');
                        var mailingQuantity = _this.model.get('mailingService').get('quantity');
                        var sideCount = _this.model.getSideCount();

                        //set equal or bigger quantity for product depending on mailing quantity
                        if (mailingQuantity > itemQuantity) {
                            var newSku = pricingCalcItem.get('skus').find(function(pricingCalcSku) {
                                var sku = pricingCalcSku.get('sku');
                                return (
                                    pricingCalcSku.get('enabled') &&
                                    sku.get('sides') === sideCount &&
                                    sku.get('quantity') >= mailingQuantity
                                );
                            });
                            _this.pricingCalculator.changeSku(newSku.get('sku').get('id'), pricingCalcItem);
                        }

                        _this.updateMailingServiceOption();
                    }
                });
            },

            /**
             * @param {string} optionValueName
             */
            updateMailingServiceOption: function(optionValueName) {
                var pricingCalcItem = this.model.get('pricingCalcItem');
                var selectedOptionValueName = pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_MAILING_SERVICE);
                var mailingQuantity = this.model.get('mailingService').get('quantity');
                var selectedQuantity = pricingCalcItem.get('mailingListRecords');
                if (optionValueName === OptionValueModel.NAME_NONE_MAILING_SERVICE) {
                    mailingQuantity = 0;
                }
                pricingCalcItem.set('mailingListRecords', mailingQuantity);
                // Only add mailing_service option if mailingQuantity > 0
                if (!optionValueName || optionValueName === OptionValueModel.NAME_MAILING_SERVICE) {
                    optionValueName =
                        mailingQuantity > 0 ? OptionValueModel.NAME_MAILING_SERVICE : OptionValueModel.NAME_NONE_MAILING_SERVICE;
                }
                if (optionValueName !== selectedOptionValueName || selectedQuantity !== mailingQuantity) {
                    this.pricingCalculator.changeOption(optionValueName, OptionModel.NAME_MAILING_SERVICE, pricingCalcItem);
                }
            },

            initPricing: function() {
                var _this = this;
                _this.getDiscountCode().done(function(data, textStatus, xhr) {
                    _this.getProducts();
                });
            },

            getDiscountCode: function() {
                var _this = this;
                return $.getJSON(router.generate('/_start_page_javascript_discount_code'), { code: browser.getUrlVars().code }, function(
                    data
                ) {
                    _this.pricingCalculator.setDiscountCode(data.code);
                    _this.pricingCalculator.setPricingSetName(data.pricingSetName);
                });
            },

            getProducts: function() {
                var _this = this;
                var processor = new OperationProcessor();

                processor.add(
                    productApi.getProducts({
                        group: _this.model.get('productGroup').get('slug')
                    })
                );

                processor
                    .getOperation()
                    .on('success', function(productsDTO) {
                        _this.setProducts(productsDTO);
                        if (_this.model.get('gallery')) {
                            _this.model.get('gallery').set('product', _this.model.get('product'));
                        }
                        _this.setPricingCalcItems();
                        _this.setStartFiles();
                    })
                    .start();
            },

            /**
             * @param {Object} productsDTO
             */
            setProducts: function(productsDTO) {
                var _this = this;
                _.each(productsDTO._embedded.items, function(productDTO) {
                    var product = new ProductModel().fromDTO(productDTO);
                    if (product.get('enabled')) {
                        _this.model.get('products').add(product);
                    }
                });
                var selectedProduct = _this.model.get('products').first();
                var defaultProductSlug = _this.model.get('defaultProduct');
                if (defaultProductSlug) {
                    var defaultProduct = _this.model.get('products').findWhere({ slug: defaultProductSlug });
                    if (defaultProduct) {
                        selectedProduct = defaultProduct;
                    }
                }
                if (selectedProduct) {
                    _this.model.set('product', selectedProduct);
                }
                _this.model.get('eventAgent').trigger('StartPage:setProducts');
            },

            setPricingCalcItems: function() {
                var _this = this;
                this.model.get('products').each(function(product) {
                    _this.pricingCalculator.createItem(product, _this.model.get('currency'), function(pricingCalcItem) {
                        pricingCalcItem.set({
                            eventAgent: _this.model.get('eventAgent')
                        });
                        //hide options that are not in the list
                        pricingCalcItem.get('options').each(function(pricingCalcOption) {
                            if (
                                pricingCalcOption.get('visible') &&
                                _.contains(HIDDEN_OPTION_NAMES, pricingCalcOption.get('option').get('name'))
                            ) {
                                pricingCalcOption.set('visible', false);
                            }
                        });

                        _this.model.get('pricingCalcItems').add(pricingCalcItem);
                        _this.initializeDefaultPricingItem();
                    });
                });
            },

            setStartFiles: function() {
                var model = new StartFileWidgetModel({
                    product: this.model.get('product'),
                    products: this.model.get('products')
                });
                var startFileWidget = new StartFileWidget(model);
                this.model.set('startFileWidgetModel', model);
            },

            initializeDefaultPricingItem: function() {
                if (this.model.get('pricingCalcItem')) {
                    return;
                }

                var selectedProduct = this.model.get('product');

                if (!selectedProduct) {
                    var defaultProductSlug = this.model.get('defaultProduct');
                    if (defaultProductSlug) {
                        selectedProduct = this.model.get('products').findWhere({ slug: defaultProductSlug });
                        if (selectedProduct) {
                            this.model.set('product', selectedProduct);
                        }
                    }
                }

                if (!selectedProduct) {
                    selectedProduct = this.model.get('products').first();
                    if (selectedProduct) {
                        this.model.set('product', selectedProduct);
                    }
                }

                if (!selectedProduct) {
                    return;
                }

                var pricingCalcItem = this.model.get('pricingCalcItems').find(function(item) {
                    return item.get('product').get('slug') === selectedProduct.get('slug');
                });

                if (!pricingCalcItem) {
                    return;
                }

                var initialSkuId = this.getInitialSkuId(pricingCalcItem);
                this.pricingCalculator.selectSkuAndOptionsInitially(pricingCalcItem, initialSkuId, []);

                this.model.set('pricingCalcItem', pricingCalcItem);
                this.model.get('eventAgent').trigger('StartPage:setPricingCalcItem');
            },

            /**
             * @param {PricingCalcItemModel} pricingCalcItem
             * @returns {number|null}
             */
            getInitialSkuId: function(pricingCalcItem) {
                var defaultProductSlug = this.model.get('defaultProduct');
                if (!defaultProductSlug || pricingCalcItem.get('product').get('slug') !== defaultProductSlug) {
                    return null;
                }

                var defaultSkuId = this.model.get('defaultSkuId');
                if (defaultSkuId) {
                    var skuForId = pricingCalcItem.findSkuBy({ id: defaultSkuId });
                    if (skuForId) {
                        return defaultSkuId;
                    }
                }

                var params = {};
                var defaultSides = this.model.get('defaultSides');
                var defaultQuantity = this.model.get('defaultQuantity');

                if (defaultSides) {
                    params.sides = defaultSides;
                }

                if (defaultQuantity) {
                    params.quantity = defaultQuantity;
                }

                if (Object.keys(params).length === 0) {
                    return null;
                }

                var matchingSku = pricingCalcItem.findSkuBy(params);

                return matchingSku ? matchingSku.get('sku').get('id') : null;
            },

            /**
             * @param {string} productSlug
             */
            changeProduct: function(productSlug) {
                var product = this.model.get('products').findWhere({ slug: productSlug });
                if (product) {
                    this.model.set('product', product);
                    this.model.get('eventAgent').trigger('product:changed', productSlug);
                }
            },

            savePricingOptions: function() {
                var params = this.getOptionParams();

                $.extend(params, this.getShippingParams());

                params.itemId = this.getSelectedSkuId();

                pricingApi.savePricingOptions().start(params);
            },

            initGallery: function() {
                var _this = this;
                var galleryModel = new GalleryModel({
                    limit: 34,
                    product: _this.model.get('product')
                });
                this.model.set('gallery', galleryModel);

                this.listenTo(this.model, {
                    'change:product': function() {
                        _this.model.get('gallery').set('product', _this.model.get('product'));
                    }
                });
                this.listenTo(this.model.get('gallery'), {
                    'Gallery:chooseTemplate': function(template) {
                        _this.model.set('template', template);
                    }
                });

                var gallery = new Gallery(galleryModel);
            },

            /**
             * @returns {string}
             */
            getGalleryPagePath: function() {
                var product = this.model.get('product');
                var productGroup = this.model.get('productGroup');
                var productGroupName = productGroup.get('name');
                var templateGallery = productGroup.get('gallery');
                // if pricing calc is not fully loaded yet, navigate to default product group gallery
                if (!product) {
                    if (templateGallery) {
                        return router.generate('/{productGroupName}/templates', {
                            productGroupName: productGroupName
                        });
                    } else {
                        return this.getUploadPath(this.model.get('defaultProduct'));
                    }
                }
                //for pricing calculator case
                templateGallery = product.getAttributeValue(AttributeModel.NAME_DVS_CRITERIA_NAME);
                //templateGallery is defaultGallery or designGallery (productGroupDesignGallery or productName)
                if (templateGallery) {
                    return router.generate('/{productGroupName}/templates/{gallery}', {
                        productGroupName: productGroupName,
                        gallery: templateGallery
                    });
                } else {
                    if (product.get('designers').length) {
                        return this.getUploadPath(product.get('slug'));
                    } else {
                        return router.generate('/approval');
                    }
                }
            },

            /**
             * @param {string} slug
             * @returns {string}
             */
            getUploadPath: function(slug) {
                if (!slug) {
                    return '';
                }
                if (this.model.getSideCount() > 2) {
                    return router.generate('/upload/{slug}', {
                        slug: slug,
                        new: 1,
                        pageCount: this.model.getSideCount()
                    });
                } else {
                    return router.generate('/upload/{slug}', {
                        slug: slug,
                        new: 1
                    });
                }
            },

            hasMailingService: function() {
                return this.model.get('pricingCalcItem').hasOptionValueSelected(OptionValueModel.NAME_MAILING_SERVICE);
            },

            getOptionParams: function() {
                var productSlug = this.model.get('product').get('slug');
                var pricingCalcItem = this.model.get('pricingCalcItem');

                if (productSlug.indexOf('booklets') !== -1) {
                    return {
                        productType: productSlug,
                        numOfSides: this.model.getSideCount(),
                        discountCode: this.model.get('pricingCalc').get('discountCode'),
                        booklets_substrate: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SUBSTRATE) || 0,
                        booklets_cover_substrate: pricingCalcItem.getSelectedOptionValueName('cover_substrate') || 0,
                        booklets_cover_coating: pricingCalcItem.getSelectedOptionValueName('cover_coating') || 0,
                        booklets_binding: pricingCalcItem.getSelectedOptionValueName('binding') || 0
                    };
                }

                return {
                    productType: productSlug,
                    discountCode: this.model.get('pricingCalc').get('discountCode'),
                    front_coating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_COATING),
                    front_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_FOIL_COLOR),
                    back_coating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_COATING),
                    back_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_FOIL_COLOR),
                    envelope: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_ENVELOPE),
                    filling: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FILLING) || 0,
                    folding: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FOLDING),
                    scoring: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SCORING),
                    holeDrilling: pricingCalcItem.hasOptionValueSelected(OptionValueModel.NAME_HOLE_DRILLING) ? 1 : 0,
                    mailing_service: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_MAILING_SERVICE),
                    mailing_service_class: this.model.get('mailingService').get('mailingClass'),
                    roundCorners: pricingCalcItem.hasOptionValueSelected(OptionValueModel.NAME_ROUNDED_CORNERS) ? 1 : 0,
                    substrate: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SUBSTRATE) || 0,
                    thickness: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_THICKNESS) || 0,
                    trimming: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_TRIMMING),
                    tShirtColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_COLOR),
                    tShirtSize: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_SIZE),
                    frontSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_SPOT_UV_COVERAGE),
                    backSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_SPOT_UV_COVERAGE),
                    closure_type: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CLOSURE_TYPE),
                    caseColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CASE_COLOR)
                };
            },
            /**
             * Returns params for pickup or normal delivery that will be used to preset shipping on shopping cart
             *
             * @returns {Object}
             */
            getShippingParams: function() {
                var $shippingMethodSelectElement = $('#delivery-or-pickup-select');
                var $zipCodeInput = $('input#zip-code');
                var pickupLocation = null;
                var $selectedMethodElement;
                var zip;

                if (!$zipCodeInput.val() || $zipCodeInput.hasClass('error') || isNaN($zipCodeInput.val())) {
                    return {};
                }

                var $shippingMethodSelectElementSelected = $shippingMethodSelectElement.find('option:selected');
                if ($shippingMethodSelectElement.length && $shippingMethodSelectElement.attr('disabled') === 'disabled') {
                    return {};
                } else if ($shippingMethodSelectElement.length && $shippingMethodSelectElementSelected.val() === 'pickup') {
                    //pickup
                    $selectedMethodElement = $('#pickup').find('option:selected');
                    pickupLocation = $selectedMethodElement.data('id');
                    zip = $selectedMethodElement.data('location-postal-code');
                } else {
                    //normal delivery
                    $selectedMethodElement = $('#delivery').find('option:selected');
                    zip = $zipCodeInput.val();
                }

                return {
                    zip: zip,
                    pickupLocation: pickupLocation,
                    shippingCategory: $selectedMethodElement.data('shipping-category'),
                    carrierServiceCode: $selectedMethodElement.data('shipping-carrier-service-code')
                };
            },

            updateShippingPrices: function() {
                var _this = this;
                var processor = new OperationProcessor();

                var zip = this.model.get('pricingCalc').get('zip');
                var validation = this.validateZip(zip);
                if (validation === true) {
                    processor.add(this.getShippingOperation());
                    this.model.get('eventAgent').trigger('StartPage:zipValidated');
                } else if (typeof validation === 'object' && validation.error) {
                    this.pricingCalculator.setShippingPrice(null);
                    this.model.get('eventAgent').trigger('StartPage:zipError', validation.error);
                }

                processor
                    .getOperation()
                    .start()
                    .once('success', function() {
                        _this.updateTotalPrices();
                    });
            },

            /**
             * validate shipping zip code
             *
             * @param {string|null|undefined} zip
             **/
            validateZip: function(zip) {
                if (zip === undefined) {
                    return false;
                }

                if (!zip) {
                    return { error: ERROR_TXT_ZIP_REQUIRED };
                }

                var $zipCodeInput = $('input#zip-code');
                if ($zipCodeInput.data('country') === 'US' && (isNaN(zip) || zip.length !== 5)) {
                    return { error: ERROR_TXT_ZIP_NOT_VALID };
                }

                return true;
            },

            /**
             * @returns {AjaxOperation}
             */
            getShippingOperation: function() {
                var _this = this;
                var optionParams = this.getOptionParams();

                var params = _.extend(optionParams, {
                    item: this.getSelectedSkuId(),
                    zip: this.model.get('pricingCalc').get('zip'),
                    isPickupAnywhere: 1
                });

                return pricingApi
                    .getShippingPrices(params)
                    .on('success', function(data) {
                        //todo refactor availableShipping structure
                        _this.pricingCalculator.setAvailableShipping(data);
                    })
                    .on('failed', function() {
                        _this.model.get('pricingCalc').trigger('pricingApi:shippingError');
                    });
            },

            updateTotalPrices: function() {
                var mailingTotal = 0;
                if (this.hasMailingService() && this.model.get('mailingService').get('price')) {
                    mailingTotal = parseFloat(this.model.get('mailingService').get('price'));
                }
                let total = this.model.get('pricingCalcItem').calculateSalePrice(true) + mailingTotal;
                this.model.get('eventAgent').trigger('StartPage:totalPriceUpdated', total);
            },

            getSelectedSkuId: function() {
                return this.model
                    .get('pricingCalcItem')
                    .getSelectedSku()
                    .get('sku')
                    .get('id');
            }
        };

        return StartPage;
    }
);
